import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import BackPageBtn from "../BackButton/BackPageBtn";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import HomeServices from "../../Services/HomeServices";
import Swal from "sweetalert2";

const CalendarNotes = () => {
  const location = useLocation();

  const { user } = location?.state || "";
  const [reminderObject, setReminderObject] = useState({
    userId: user?.userData?._id,
    calenderDate: "",
    notes: "",
  });
  const [fetchCalenderReminderLoading, setFetchCalenderReminderLoading] =
    useState(false);
  const [calenderReminders, setCalenderReminders] = useState([]);
  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [editReminder, setEditReminder] = useState(null);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);
  console.log("Calender", user);
  const customStyles = {
    rows: {
      style: {
        padding: "1em 0",
      },
    },
  };

  function formatDateToReadableString(dateString) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    // Function to add suffix to day (1st, 2nd, 3rd, etc.)
    const getDaySuffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${getDaySuffix(day)} ${month} ${year}`;
  }

  function formatDateToYYYYMMDD(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const column = [
    {
      name: "Sl No",
      selector: (row, index) => index + 1,
      wrap: true,
      center: true,
    },

    {
      name: "Date",
      selector: (row) => formatDateToReadableString(row?.calenderDate),
      wrap: true,
      center: true,
    },
    {
      name: "Notes",
      selector: (row) => row.notes,
      wrap: true,
      center: true,
    },
    {
      name: "Added By",
      selector: (row) => row.addedByType,
      wrap: true,
      center: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          {/* <i
            className="fas fa-edit"
            style={{
              color: "#32a852",
              fontSize: "15px",
              cursor: "pointer",
            }}
            onClick={() => {
              setEditReminder(row);
              console.log(row);
            }}
          ></i> */}

          <i
            onClick={() => {
              handleDelete(row?._id);
            }}
            className="fa fa-trash"
            style={{
              color: "red",
              fontSize: "15px",
              cursor: "pointer",
            }}
          ></i>
        </div>
      ),
      wrap: true,
      center: true,
    },
  ];

  const fetchCalenderReminder = async () => {
    try {
      setFetchCalenderReminderLoading(true);
      const response = await HomeServices.getCalenderReminderByUserId(
        user?.userData?._id,
      );
      console.log("Calender Get", response);
      if (response?.status) {
        setCalenderReminders(response?.data?.reverse());
        setFetchCalenderReminderLoading(false);
      } else {
        toast.error("Error fetching calender data");
        setFetchCalenderReminderLoading(false);
      }
    } catch (error) {
      toast.error(error);
      setFetchCalenderReminderLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCalenderReminder();
  }, []);

  // const handleAddReminder = async () => {
  //   if (!reminderObject?.notes || !reminderObject?.calenderDate) {
  //     toast.error("Please Enter All fields!");
  //     return;
  //   }

  //   try {
  //     setAddReminderLoading(true);
  //     const response = await HomeServices.addReminder(reminderObject);
  //     if (response.status) {
  //       toast.success(response.message);
  //       setReminderObject((prev) => ({ ...prev, notes: "", calenderDate: "" }));
  //       // setReminderObject({ notes: "", calenderDate: "" });
  //       fetchCalenderReminder();
  //       setAddReminderLoading(false);
  //     } else {
  //       toast.error(response.message);
  //       setAddReminderLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error Creating Reminder:", error);
  //     setAddReminderLoading(false);
  //   }
  // };

  // const handleUpdateReminder = async () => {
  //   if (!editReminder?.notes || !editReminder?.calenderDate) {
  //     toast.error("Please Enter All fields!");
  //     return;
  //   }

  //   try {
  //     setUpdateReminderLoading(true);
  //     const response = await HomeServices.updateCalenderReminder(
  //       editReminder?._id,
  //       {
  //         userId: user?._id,
  //         calenderDate: editReminder?.calenderDate,
  //         notes: editReminder?.notes,
  //       },
  //     );
  //     if (response.status) {
  //       toast.success(response.message);
  //       fetchCalenderReminder();
  //       setEditReminder(null);
  //       setUpdateReminderLoading(false);
  //     } else {
  //       toast.error(response.message);
  //       setUpdateReminderLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error Creating Reminder:", error);
  //     setUpdateReminderLoading(false);
  //   }
  // };

  // Helper function to add one day to a date (UTC safe)
  const addOneDayToDateUTC = (dateString) => {
    if (!dateString) return "";

    // Parse the date string and create UTC date
    const [year, month, day] = dateString.split("-");
    const date = new Date(Date.UTC(year, month - 1, day));

    // Add one day in UTC
    date.setUTCDate(date.getUTCDate() + 1);

    // Format back to YYYY-MM-DD
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(date.getUTCDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const handleAddReminder = async () => {
    if (!reminderObject?.notes || !reminderObject?.calenderDate) {
      toast.error("Please Enter All fields!");
      return;
    }

    try {
      setAddReminderLoading(true);

      // Create a copy of reminderObject and modify the date with UTC
      const modifiedReminderObject = {
        ...reminderObject,
        calenderDate: addOneDayToDateUTC(reminderObject.calenderDate),
      };

      const response = await HomeServices.addReminder(modifiedReminderObject);
      if (response.status) {
        toast.success(response.message);
        setReminderObject((prev) => ({ ...prev, notes: "", calenderDate: "" }));
        fetchCalenderReminder();
        setAddReminderLoading(false);
      } else {
        toast.error(response.message);
        setAddReminderLoading(false);
      }
    } catch (error) {
      console.error("Error Creating Reminder:", error);
      setAddReminderLoading(false);
    }
  };

  function formatDate(dateInput) {
    if (!dateInput) return "";

    const date = new Date(dateInput);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const handleUpdateReminder = async () => {
    if (!editReminder?.notes || !editReminder?.calenderDate) {
      toast.error("Please Enter All fields!");
      return;
    }

    try {
      setUpdateReminderLoading(true);

      // Create a copy and modify the date with UTC for update
      const modifiedUpdateData = {
        userId: user?._id,
        calenderDate: addOneDayToDateUTC(
          formatDate(editReminder?.calenderDate),
        ),
        notes: editReminder?.notes,
      };

      const response = await HomeServices.updateCalenderReminder(
        editReminder?._id,
        modifiedUpdateData,
      );
      if (response.status) {
        toast.success(response.message);
        fetchCalenderReminder();
        setEditReminder(null);
        setUpdateReminderLoading(false);
      } else {
        toast.error(response.message);
        setUpdateReminderLoading(false);
      }
    } catch (error) {
      console.error("Error Creating Reminder:", error);
      setUpdateReminderLoading(false);
    }
  };
  const handleDelete = async (id) => {
    console.log("deleteblogid", id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      console.log("result", result);
      if (result?.isConfirmed) {
        HomeServices.deleteCalenderReminder(id)
          .then((res) => {
            // console.log("deleteBlogresponse", res);

            if (res && res.status) {
              toast.success("Deleted Successfully");
              fetchCalenderReminder();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((err) => {
            console.error("Error deleting Reminder:", err);
          });
      } else {
        console.log("Deletion canceled");
      }
    });
  };

  return (
    <>
      {!editReminder && (
        <div className="d-flex justify-content-end">
          <div className="form-header">
            <div style={{ marginBottom: "25px" }}>
              <BackPageBtn backLink="/users" />
            </div>

            <section className="piechartsBox_area">
              <h1
                style={{
                  color: "#ff9c00",
                  fontSize: "25px",
                  fontWeight: "600",
                  marginBottom: "25px",
                }}
              >
                Reminder
              </h1>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Choose Date</label>

                  <input
                    className="form-control"
                    type="date"
                    style={{ cursor: "pointer" }}
                    value={reminderObject?.calenderDate}
                    onChange={(e) => {
                      setReminderObject((prev) => ({
                        ...prev,
                        calenderDate: e?.target?.value,
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Remarks/Message</label>

                  <textarea
                    className="form-control"
                    placeholder="Enter Your Notes"
                    name="note"
                    value={reminderObject?.notes}
                    onChange={(e) => {
                      setReminderObject((prev) => ({
                        ...prev,
                        notes: e?.target?.value,
                      }));
                    }}
                  />
                </div>
              </div>

              <div class="col-12 ">
                <button
                  disabled={addReminderLoading}
                  // type="submit"
                  onClick={() => handleAddReminder()}
                  class="btn btn-primaryb mt-3 addBlogBtn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  {addReminderLoading ? "Adding..." : "Add"}
                </button>
              </div>
            </section>
          </div>
        </div>
      )}
      {editReminder && (
        <div className="d-flex justify-content-end">
          <div className="form-header">
            <section className="piechartsBox_area">
              <h1
                style={{
                  color: "#ff9c00",
                  fontSize: "25px",
                  fontWeight: "600",
                  marginBottom: "25px",
                }}
              >
                Update Reminder
              </h1>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Choose Date</label>

                  <input
                    className="form-control"
                    type="date"
                    style={{ cursor: "pointer" }}
                    value={formatDateToYYYYMMDD(editReminder?.calenderDate)}
                    onChange={(e) => {
                      setEditReminder((prev) => ({
                        ...prev,
                        calenderDate: e?.target?.value,
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Remarks/Message</label>

                  <textarea
                    className="form-control"
                    placeholder="Enter Your Notes"
                    name="note"
                    value={editReminder?.notes}
                    onChange={(e) => {
                      setEditReminder((prev) => ({
                        ...prev,
                        notes: e?.target?.value,
                      }));
                    }}
                  />
                </div>
              </div>

              <div class="col-12 ">
                <button
                  disabled={updateReminderLoading}
                  // type="submit"
                  onClick={() => handleUpdateReminder()}
                  class="btn btn-primaryb mt-3 addBlogBtn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  {updateReminderLoading ? "Updating..." : "Update"}
                </button>
                <button
                  disabled={updateReminderLoading}
                  // type="submit"
                  onClick={() => {
                    setEditReminder(null);
                  }}
                  class="btn btn-primaryb mt-3 addBlogBtn"
                  style={{
                    background: "linear-gradient(195deg, #e33010, #f05b41)",
                    color: "#fff",
                    marginLeft: "15px",
                  }}
                >
                  Cancel
                </button>
              </div>
            </section>
          </div>
        </div>
      )}
      {!editReminder && (
        <div className="d-flex justify-content-end">
          <div className="form-header">
            <section className="piechartsBox_area">
              <div>
                <div className="dateListDiv">
                  <h1
                    style={{
                      color: "#ff9c00",
                      fontSize: "25px",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    <div>
                      <span style={{ fontSize: "80%", color: "#000" }}></span>
                    </div>
                    Reminder Notes
                  </h1>
                </div>
              </div>

              <hr />
              <DataTable
                columns={column}
                data={calenderReminders}
                customStyles={customStyles}
                pagination
                progressPending={fetchCalenderReminderLoading}
              />
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default CalendarNotes;
